import { useIsMobile } from './useIsMobile';

export function usePlatformDefaultCtrlSize() {
  // ios is stupid and zooms in automatically on inputs with font size less than 16px 
  return useIsMobile() ? 'md' : 'sm';
}
